import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Routes, Route } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import SideNavBar from './SideNavBar';
import Alerts from './Alerts';
import Queue from './Queue';
import CheckIn from './CheckIn';
import Reports from './Reports';
import Configuration from './Configuration';
import Users from './Users';
import AuditLog from './AuditLog';
import useVersionCheck from '../../hooks/useVersionCheck';
import { GetUser, Logout, setPushAlert, onSocketStatus } from '../../api';

const drawerWidth = 240;

const theme = createTheme({
  palette: { mode: 'dark' },
  typography: {
    button: { fontWeight: 400 },
    h1: { fontWeight: 100 }, h2: { fontWeight: 300 }, h3: { fontWeight: 300 },
    h4: { fontWeight: 300 }, h5: { fontWeight: 300 }, h6: { fontWeight: 300 },
  },
});

const Portal = () => {
  const [user, setUser] = useState();
  const [access, setAccess] = useState();
  const [alerts, setAlerts] = useState([]);
  const [socketStatus, setSocketStatus] = useState();
  const [mobileOpen, setMobileOpen] = useState(false);
  const updateAvailable = useVersionCheck();

  useEffect(() => {
    setPushAlert(alert => setAlerts(a => [...a, alert]));
    onSocketStatus(status => setSocketStatus(status));
    return () => { setPushAlert(); onSocketStatus(); };
  }, []);

  useEffect(() => {
    GetUser()
      .then(resp => {
        if (!resp) return Logout();
        setUser(resp);
        const savedOrg = localStorage.getItem('LobbyOrg') || resp.org?.id;
        const acc = (savedOrg && resp.access?.find(e => savedOrg === e.org?.id)) || resp.access?.[0];
        setAccess(acc);
      })
      .catch(() => Logout());
  }, []);

  useEffect(() => {
    if (access?.org?.id) localStorage.setItem('LobbyOrg', access.org.id);
  }, [access]);

  if (!user || !access) return null;

  return (
    <ThemeProvider theme={theme}>
      <TopNavBar handleDrawerToggle={() => setMobileOpen(o => !o)} user={user} />
      <Alerts alerts={alerts} setAlerts={setAlerts} updateAvailable={updateAvailable} />
      <Box sx={{ display: 'flex' }}>
        <SideNavBar
          handleDrawerToggle={() => setMobileOpen(o => !o)}
          mobileOpen={mobileOpen}
          access={access}
        />
        <Box component="main" sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}>
          <Routes>
            <Route path="/check-in" element={<CheckIn user={user} access={access} />} />
            <Route path="/reports/*" element={<Reports access={access} />} />
            <Route path="/configuration/*" element={<Configuration access={access} />} />
            <Route path="/users" element={<Users access={access} />} />
            <Route path="/audit" element={<AuditLog access={access} />} />
            <Route path="*" element={<Queue user={user} access={access} socketStatus={socketStatus} />} />
          </Routes>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Portal;
